import { render, staticRenderFns } from "./SelectorIdioma.vue?vue&type=template&id=6ddd6dce&scoped=true"
import script from "./SelectorIdioma.vue?vue&type=script&lang=js"
export * from "./SelectorIdioma.vue?vue&type=script&lang=js"
import style0 from "./SelectorIdioma.vue?vue&type=style&index=0&id=6ddd6dce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddd6dce",
  null
  
)

export default component.exports